import { FC, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Context } from "../..";
import { Button, CustomLink, Layout, MasterCard, MasterTable, Result } from "../../components";
import logo from "../../assets/logo.svg";
import config from "../../config";
import { Master, Response } from "../../types";
import $api from "../../http";
import { AxiosResponse } from "axios";
import { observer } from "mobx-react";

const DeleteMaster: FC<{ title: string }> = observer(({ title }) => {
  const navigate = useNavigate();
  const { store } = useContext(Context);
  useEffect(() => {
    if (!store.isAuth) return navigate("/");
    if (store.user.type !== "admin") return navigate(`/${store.user.type}`);
  }, [navigate, store.isAuth, store.user.type]);

  const [masters, setMasters] = useState<Master[]>();
  const [selectedMaster, setSelectedMaster] = useState<Master>();
  const [result, setResult] = useState<Response>({status: "error", message: ""});

  useEffect(() => {
    $api.get(`${config.API}/master/all`).then(({ data }) => {
      setMasters(data.data);
    });
  }, []);

  const sendData = () => {
    if (selectedMaster) {
      $api.delete(`${config.API}/master/delete`, {data: { id: selectedMaster._id }}).then(({ data }: AxiosResponse<Response>) => {
        setResult({...data});
      });
    }
  };
  return (
    <Layout title={title}>
      <img src={logo} alt="Chiorio logotype" width={120} height={120} style={{ marginBottom: 50 }} />
      <CustomLink to={"/admin"}>{"<-"} Админ панель</CustomLink>
      <MasterTable>
        {masters &&
          masters.map((e: Master) => (
            <MasterCard key={e.name} name={e.name} photo={`${config.API}/${e.photo}`} stat={e.stat} onClick={() => setSelectedMaster(e)} />
          ))}
      </MasterTable>
      {selectedMaster && (
        <>
          <p>Вы уверены, что хотите удалить мастера «{selectedMaster.name}»</p>
          <Button onClick={sendData}>Да, удалить</Button>
          <Result {...result} />
        </>
      )}
    </Layout>
  );
});

export default DeleteMaster;
